import { format, getTime, formatDistanceToNow, isValid } from 'date-fns';
import { es } from 'date-fns/locale';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}
export function fDateFront(date) {
  if (isValid(new Date(date))) return format(new Date(date), 'dd/MM/yyyy');

  return date;
}

export function fDateLogic(date) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
    locale: es,
  });
}

export function fDateFormat(date, formatDefault = 'yyyy-MM-dd') {
  return format(new Date(date), formatDefault);
}

export function isValidDate(date) {
  return isValid(new Date(date));
}
